import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import RolesEditForm from './RolesEditForm';

const RolesEdit = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Role" title="Edit role" subParent="Roles" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Edit role</H5>
                <Link to="/roles">
                  <Btn color="primary">Back to roles</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <RolesEditForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Create</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RolesEdit;
